import { render, staticRenderFns } from "./ProxyView.vue?vue&type=template&id=0787f81d&scoped=true"
import script from "./ProxyView.ts?vue&type=script&lang=ts&external"
export * from "./ProxyView.ts?vue&type=script&lang=ts&external"
import style0 from "./ProxyView.vue?vue&type=style&index=0&id=0787f81d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0787f81d",
  null
  
)

export default component.exports